import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35c00a5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "certMask" }, null, -1))
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "tips" }

import { ref, onMounted } from "vue";
import gsap from "gsap";
import store from "@/store";
import { postCertByStudent, studentCertType } from "@/api/request/user";

export default /*#__PURE__*/_defineComponent({
  __name: 'NewCertificate',
  setup(__props) {

const studentCertInfo = ref({} as studentCertType);
const newCertificateRef = ref();
function resizeFun() {
  //监听浏览器窗口大小改变
  //浏览器变化执行动作
  console.log(window.devicePixelRatio);
  newCertificateRef.value.style.transformOrigin = "center";
  newCertificateRef.value.style.transform =
    "translateX(-50%) scale(" + window.devicePixelRatio + ")";
}
onMounted(() => {
  // 查询学员是否获得新证书
  console.log("查询证书");
  postCertByStudent().then((res) => {
    if (
      res.data.length > 0 &&
      store.state.user.userInfo.type &&
      store.state.user.userInfo.type !== "0"
    ) {
      studentCertInfo.value = res.data[0];
      document.getElementsByTagName("body")[0].classList.add("g-hidden");
      window.addEventListener("resize", resizeFun);
    }
  });
});
const isShow = ref(true);
function close() {
  gsap
    .timeline({
      onComplete: () => {
        console.log("动画完成");
        isShow.value = false;
        document.getElementsByTagName("body")[0].classList.remove("g-hidden");
        window.removeEventListener("resize", resizeFun);
      },
    })
    .to(".newCertificateContainer", {
      top: 100,
      left: 1000,
      width: 100,
      height: 100,
      borderRadius: 50,
    })
    .to(".newCertificateContainer", {
      top: 20,
      left: 1000,
      width: 0,
      height: 0,
    });
  gsap.to(".newCertificate", {
    top: 0,
  });
}

return (_ctx: any,_cache: any) => {
  const _directive_cdn = _resolveDirective("cdn")!

  return (isShow.value && studentCertInfo.value.certificateImg)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "newCertificateContainer",
        onClick: close
      }, [
        _hoisted_1,
        _createElementVNode("div", {
          ref_key: "newCertificateRef",
          ref: newCertificateRef,
          class: "newCertificate"
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("恭喜您获得了N认证证书", {
            text: studentCertInfo.value.certificateTitle,
          })), 1),
          _withDirectives(_createElementVNode("img", {
            src: studentCertInfo.value.certificateImg,
            alt: ""
          }, null, 8, _hoisted_3), [
            [_directive_cdn]
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("可前往『 我的成就-我的认证』中查看")), 1)
        ], 512)
      ]))
    : _createCommentVNode("", true)
}
}

})